<template>
  <div class="minimap">
    <div id="minimapid" ref="minimapId"></div>
  </div>
</template>
<script>

export default {
  name: 'MiniMap',
  props: {
    latlongstatus: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      leafletMap: null,
      colors: ['#4CAF50', '#FF9800', '#F44336', '#2196F3'],
      marker: null
    }
  },
  beforeCreate: function () {
  },
  created: function () {
  },
  watch: {
    latlongstatus: function (val) {
      var iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png'
      if (val) {
        if (val.opmode === 5) {
          iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png'
        } else {
          switch (val.status) {
            case 1:
              iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png'
              break
            case 2:
              iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-orange.png'
              break
            case 3:
              iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png'
              break
            default:
              iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png'
              break
          }
        }
        var myIcon = L.icon({
          iconUrl: iconUrl,
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        })
        this.marker = L.marker(val.latLong, {icon: myIcon}).addTo(this.leafletMap)
        this.leafletMap.setView(val.latLong, 12)
      }
    }
  },
  mounted: function () {
    const mapElement = this.$refs.minimapId // $(element).find('#mapid')[0]
    const accesstoken = 'pk.eyJ1Ijoia2FyaW5sb29zIiwiYSI6ImNqOGVhczRnNDBuMjkzM3FseXdybjd0Y2EifQ.NHM9Pss5TvDSIQZXIWktCA'

    // var latlng = L.latLng(this.latitude, this.longititude)
    let latlng = L.latLng(52.2574121, 6.7927725)
    // let tiles = L.tileLayer(
    //   'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
    //   {
    //     maxZoom: 18,
    //     attribution: 'Strukton',
    //     maxNativeZoom: 19,
    //     id: 'mapbox.streets',
    //     accessToken: accesstoken
    //   })
    var tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Strukton',
      maxZoom: 17,
      id: 'mapbox/streets-v11',
      accessToken: accesstoken
    })
    this.leafletMap = L.map(mapElement, {
      center: latlng, zoom: 5, layers: [tiles]
    })
  }
}
</script>
<style scoped>
  #minimapid {
    height: 180px;
    width: 100%;
  }
  .minimap {
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/map.vue